import React from "react";
import Tour, { ReactTourContent } from "@inspinia-react/tour";
import { api, put, getUser, consts } from "@config";

const user = getUser();



export default props => {
  function onCloseTour() {
    const url = `${api.users.register}${user.id}/`
    const data = { home_tour: true, email: user.email, timezone: "America/Belem" }
    const payload = resp => {
      window.localStorage.setItem(consts.USER_DATA, JSON.stringify(resp));
      setTimeout(() => window.location.href = "/branches/create", 300);
    } 
    put( url, data, payload);
  }

  return (
    <Tour
      onCloseTour={() => onCloseTour()}
      badgeVerbose
      steps={[
        {
          selector: "container",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent
              title={`Olá, ${user.name}.`}
              goTo={goTo}
              inDOM={inDOM}
              step={step}
            >
              <h2 className="text-center py-2">
                Bem vindo ao <strong>EasyGestor online</strong>
              </h2>
              <h3>Vamos conhecer o seu novo sistema?</h3>
            </ReactTourContent>
          )
        },
        {
          selector: "#sales-total-resume",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent
              title="Resumo de vendas"
              goTo={goTo}
              inDOM={inDOM}
              step={step}
            >
              <p>
                Aqui você verá um resumo das suas vendas. O total de vendas
                mensais, diárias e anual.
              </p>
            </ReactTourContent>
          )
        },
        {
          selector: "#month-sales",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent
              title="Gráfico de vendas"
              goTo={goTo}
              inDOM={inDOM}
              step={step}
            >
              <p>As suas vendas do mês estarão disponíveis neste gráfico.</p>
            </ReactTourContent>
          )
        },
        {
          selector: "#payments-methods",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent
              title="Formas de pagamentos"
              goTo={goTo}
              inDOM={inDOM}
              step={step}
            >
              <p>
                Além disso você também poderá visualizar quais foram as formas
                de pagamentos mais utilizadas.{" "}
              </p>
            </ReactTourContent>
          )
        },
        {
          selector: "#dashboard-salestimeline",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent
              title="Últimas vendas"
              goTo={goTo}
              inDOM={inDOM}
              step={step}
            >
              <p>
                As suas últimas vendas serão exibidas aqui nesta linha do tempo.
              </p>
            </ReactTourContent>
          )
        },
        {
          selector: "#small-chat",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent
              title="Suporte"
              goTo={goTo}
              inDOM={inDOM}
              step={step}
            >
              <p>
                Qualquer dúvida que você tiver, você poderá acessar o chat e
                falar diretamento com o nosso suporte técnico.
              </p>
            </ReactTourContent>
          )
        },
        {
          selector: "container",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent
              title="Cadastro de filial"
              goTo={goTo}
              inDOM={inDOM}
              step={step}
            >
              <p className="lead">
                O <strong>EasyGestor online</strong> trabalha com gestão de
                vendas. Para isso é preciso ter pelo menos uma filial
                cadastrada. Vamos criar uma filial agora?
              </p>

              <button
                onClick={() => onCloseTour()}
                className="btn btn-primary btn-sm my-2 btn-block"
              >
                Criar Filial
              </button>
            </ReactTourContent>
          )
        }
      ]}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/tours/dashboard-tour.jsx